import {
  ADD_PROFILES,
  IEntityProfilesState,
  ProfilesActionTypes,
  REMOVE_PROFILE,
  REPLACE_PROFILES
} from '../../types/entity/profiles';
import {INIT_STORE} from "../../types/init";
import lod from 'lodash';

const initialState: IEntityProfilesState = {
  byId: {},
  allIds: []
};

export function entityProfilesReducer(
  state = initialState,
  action: ProfilesActionTypes
): IEntityProfilesState {
  switch (action.type) {
    case INIT_STORE:
      return initialState;
    case REPLACE_PROFILES: {
      return {
        byId: lod.keyBy(action.payload.profiles, 'id'),
        allIds: lod.map(action.payload.profiles, 'id')
      };
    }
    case REMOVE_PROFILE: {
      return {
        byId: lod.omit(state.byId, action.payload.id),
        allIds: state.allIds.filter(id => id !== action.payload.id)
      };
    }
    case ADD_PROFILES: {
      return {
        byId: {
          ...state.byId,
          ...lod.keyBy(action.payload.profiles, 'id')
        },
        allIds: [
          ...state.allIds,
          ...lod.map(action.payload.profiles, 'id').filter(id => !state.byId[id])
        ]
      };
    }
    default:
      return state;
  }
}